import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom'
import { ChangePasswordType } from '../interface'
import { IoEyeOffOutline } from "react-icons/io5";
import { IoEyeOutline } from "react-icons/io5";
import { ExamcompassClient } from '../Api/api';


// svg
import logoTwo from '../Assets/compass-logo-2.svg'
import kitchen from '../Assets/kitchen.svg'
import dottedLine from '../Assets/dotted.svg'
import axios from 'axios';



type ChangePasswordPropsType = {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>
}

const ChangePassword: React.FC<ChangePasswordPropsType> = ({ showPassword, setShowPassword}) => {
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const uid = queryParams.get('uid');
  const token = queryParams.get('token');

  const [changePassword, setChangePassword] = useState<ChangePasswordType>({
    password: "",
    confirmPassword: ""
  })
  const [passwordError, setPasswordError] = useState<string>('');
  const [tokenError, setTokenError] = useState<string>('');

  const handlePasswordChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    const { name, value } = e.target;
    setChangePassword(prev => ({ ...prev, [name]: value }))
  }
  
  
  const userDetails = {
    uid: uid,
    token: token,
    password: changePassword.password
  }
  console.log('userDetail', userDetails)
  const navigate = useNavigate();

  const changeUserPassword = async(e:React.FormEvent) => {
    e.preventDefault();

    const userDetails = {
      uid: uid,
      token: token,
      password: changePassword.password
    }

    try {
      await ExamcompassClient.post('/profile/confirm_reset_password/', userDetails);

      setChangePassword({
        password: "",
        confirmPassword: ""
      })

      navigate('/login');
    }
    catch(error) {
      if (axios.isAxiosError(error)) {
        console.log('This is the reset error', error?.response?.data.password);

        const updateError = error?.response?.data
        if (updateError?.password) {
          setPasswordError(updateError?.password[0]);
        }
        else if (!updateError?.password) {
          setTokenError(updateError?.[0])
        }
      }
    }
  }

  return (
    <section className='w-full h-[100vh] relative bg-slate-200 overflow-hidden'>
      <div className='md:w-[50%] lg:w-[480px] h-[100%] bg-white pt-5 px-6 lg:px-16 pb-5 flex flex-col justify-between'>
        <div className='mb-6'>
          <div className='mb-2'>
            <Link to={'/'}><img className='w-[50px]' src={logoTwo} alt="ExamCompass" /></Link>
          </div>
          <div className='w-full mb-4'>
            <h2 className='w-[50%] text-[30px] text-darkGreen font-bold mb-3'>Change password</h2>
            <p className='lg:text-[14px]'>Input your new desired password in the input fields below to create a new password. We strongly advise you to store it safely.</p>
          </div>

          <img className='mb-6' src={dottedLine} alt="Line" />

          <form onSubmit={changeUserPassword}>
            <div className='mb-4'>
              <p className='text-red-700 font-bold'>{tokenError === 'Invalide token' && 'Invalid token or The token has expired'}</p>
              <div className='w-full mb-1 flex items-center justify-between'>
                <p className='lg:text-[14px]'>New Password</p>
                <p className='lg:text-[14px]  text-red-700'>{passwordError}</p>
             </div>
              <div className='px-2 border border-textColor flex items-center gap-4'>
                <input type={showPassword ? 'text' : 'password'}
                  name='password'
                  value={changePassword?.password}
                  onChange={handlePasswordChangeInput}
                  placeholder='Password'
                  className='w-full h-[40px] text-[15px] outline-none'
                />
                {showPassword ? <IoEyeOutline size={20} onClick={() => setShowPassword(false)} className='text-slate-500 cursor-pointer' /> : <IoEyeOffOutline onClick={() => setShowPassword(true)} size={20} className='text-slate-500 cursor-pointer' />}
              </div>
            </div>

            <div className='mb-4'>
              <div className='w-full mb-1 flex items-center justify-between'>
                <p className='lg:text-[14px]'>Confirm Password</p>
                <p className='lg:text-[14px]  text-red-700'>{passwordError}</p>
              </div>
              <div className='px-2 border border-textColor flex items-center gap-4'>
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name='confirmPassword'
                  value={changePassword?.confirmPassword}
                  onChange={handlePasswordChangeInput}
                  placeholder='Confirm password'
                  className='w-full h-[40px] text-[15px] outline-none'
                />
                {showConfirmPassword ? <IoEyeOutline size={20} onClick={() => setShowConfirmPassword(false)} className='text-slate-500 cursor-pointer' /> : <IoEyeOffOutline onClick={() => setShowConfirmPassword(true)} size={20} className='text-slate-500 cursor-pointer' />}
              </div>
            </div>

            <img className='mb-6' src={dottedLine} alt="Line" />

            <button className='w-full bg-darkGreen text-white lg:text-[14px] h-[39px] lg:h-[48px] rounded-[4px] cursor-pointer'>Change password</button>
          </form>
        </div>

        <div>
          <p className='text-textColor text-[14px] lg:text-[14px] font-semibold text-center'>Do you need help</p>
          <p className='text-darkGreen text-[14px] lg:text-[14px] font-semibold text-center'>Customer support</p>
        </div>
      </div>

      <img className='hidden md:block w-[1000px] md:w-[650px] lg:h-[930px] absolute md:bottom-0 lg:-bottom-44 -right-[250px] lg:-right-0' src={kitchen} alt='Lady' />
    </section>
  )
}

export default ChangePassword;